import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ellf-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BreadcrumbComponent {}
